import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'directories.filters-v2.edit-modal.title',
		defaultMessage: 'Edit filter',
		description: 'Header of the edit filter modal which is shown on the filters directory page',
	},
	submitButtonCaption: {
		id: 'directories.filters-v2.edit-modal.submit-button-caption',
		defaultMessage: 'Save',
		description: 'Label for the submit button shown in the edit filter modal',
	},
});
